import { c as _c } from "react/compiler-runtime";
import { FC, type JSX } from "react";
import { ApiWaveOutcome } from "@/generated/models/ApiWaveOutcome";
import { WaveRepOutcome } from "./WaveRepOutcome";
import { WaveNICOutcome } from "./WaveNICOutcome";
import { WaveManualOutcome } from "./WaveManualOutcome";
import { ApiWaveOutcomeCredit } from "@/generated/models/ApiWaveOutcomeCredit";
enum OutcomeType {
  MANUAL = "MANUAL",
  NIC = "NIC",
  REP = "REP",
}
interface WaveOutcomeProps {
  readonly outcome: ApiWaveOutcome;
}
export const WaveOutcome: FC<WaveOutcomeProps> = t0 => {
  const $ = _c(12);
  const {
    outcome
  } = t0;
  const getOutcomeType = () => {
    if (outcome.credit === ApiWaveOutcomeCredit.Rep) {
      return OutcomeType.REP;
    }
    if (outcome.credit === ApiWaveOutcomeCredit.Cic) {
      return OutcomeType.NIC;
    }
    return OutcomeType.MANUAL;
  };
  const outcomeType = getOutcomeType();
  let t1;
  if ($[0] !== outcome) {
    t1 = <WaveRepOutcome outcome={outcome} />;
    $[0] = outcome;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== outcome) {
    t2 = <WaveNICOutcome outcome={outcome} />;
    $[2] = outcome;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== outcome) {
    t3 = <WaveManualOutcome outcome={outcome} />;
    $[4] = outcome;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = {
      [OutcomeType.REP]: t1,
      [OutcomeType.NIC]: t2,
      [OutcomeType.MANUAL]: t3
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const component = t4;
  const t5 = component[outcomeType];
  let t6;
  if ($[10] !== t5) {
    t6 = <div>{t5}</div>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};